import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import apiClient from "../api/apiClient";

const PLACEHOLDER = "https://placehold.co/600x400/1a1a1a/ff0033?text=Library";

const SkeletonCard = () => (
  <div
    style={{
      height: "260px",
      background: "#1a1a1a",
      borderRadius: "8px",
      opacity: 0.35,
      animation: "pulse 1.5s ease-in-out infinite",
    }}
  />
);

const Gallery = () => {
  const [libraries, setLibraries] = useState([]);
  const [loading, setLoading]     = useState(true);

  useEffect(() => {
    apiClient
      .get("/libraries")
      .then((res) => setLibraries(res.data.data || []))
      .catch(() => setLibraries([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="container py-5">

      {/* Section title */}
      <div className="section-head style-1 text-center mb-5">
        <h2 className="title">
          Exercise <span>Libraries</span>
        </h2>
        <p className="p-big mx-auto" style={{ maxWidth: "600px" }}>
          Explore structured training systems designed to organise strength,
          performance, and mobility exercises.
        </p>
      </div>

      {loading ? (
        <div className="row">
          {[1, 2, 3].map((i) => (
            <div key={i} className="col-lg-4 col-sm-6 m-b30">
              <SkeletonCard />
            </div>
          ))}
        </div>
      ) : libraries.length === 0 ? (
        <p className="text-center text-muted">No libraries available.</p>
      ) : (
        <div className="row">
          {libraries.map((lib, i) => {
            const img = lib.thumbnail_url || PLACEHOLDER;
            return (
              <div
                key={lib.id}
                className="col-lg-4 col-sm-6 m-b30 wow fadeInUp"
                data-wow-delay={`${i * 0.1}s`}
              >
                <Link
                  to={`/library/${lib.slug}`}
                  style={{ textDecoration: "none", display: "block" }}
                >
                  <div className="ovarlay-box style-1 gallery">
                    <img src={img} alt={lib.name} />
                    <div className="content">
                      <div className="ovarlay-info">
                        <span className="view-btn lightimg">
                          <i className="fa-solid fa-arrow-right" />
                        </span>
                        <span className="title">{lib.name}</span>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      )}

    </div>
  );
};

export default Gallery;
